import { biHottag, elk, url } from '@tencent/ppd-base-libs';
import { isInWeixin } from '@tencent/wphk-components-common/utils/ua';
const confId = url.getUrlParam('confId');

/**
 * 设置bi事件前缀
 */
let biPrefix = 'promotion.thirdappredirect';  // 默认
export function setBiPrefix(AB?: string) {
  if (AB) {
    biPrefix = AB;
  }
}

/**
 * 设置上报方法
 */
let reportMethod: any = biHottag;
export function setReportMethod(reportAdapter?: Function) {
  if (reportAdapter) {
    reportMethod = reportAdapter;
  }
}

/**
 * 设置bi事件前缀和上报方法
 */
export function setCompReportInfo({
  eventPrefix,
  method,
}: {
  /** 数据上报前缀A.B，如果没有传入则是promotion.thirdappredirect */
  eventPrefix: string;
  /** 数据上报方法，如果没有传入，则是香港钱包的biHottag；接受两个参数事件名(A.B.C.D)和扩展字段({key:value}) */
  method: Function;
}) {
  setBiPrefix(eventPrefix);
  setReportMethod(method);
}

/**
 * 上报Bi的同时，上报elk
 */
const inWxOrThird = isInWeixin() ? 'inwx' : 'thirdapp';
export function bothReport(CD: string) {
  // 拼接上报事件
  let eventStr = `${biPrefix}.${CD}`;
  // 多个..转化为一个.
  eventStr = eventStr.replace(/\.+/g, '.');

  // 上报BI
  reportMethod(eventStr, {
    fopenid: 'opened@wx.hkg',
    fuin: 'opened@wx.hkg',
    fisinwx: inWxOrThird,
    fconfId: confId,
  });
  // 上报elk
  elk({
    key: 'third-app-redirect',
    str1: eventStr,
    str2: url.getParamAdtag(), // ADTAG
    str3: inWxOrThird,
  });
}
